import { Alert } from '@mui/material';
import { LoadingSpinner } from '../../core/LoadingSpinner';
import { useGetGlobalMails } from '../../hooks/reactQuerys/GlobalMailQueries';
import { GlobalMailView } from './GlobalMailView';

export const GlobalMailOverview = () => {
  const { globalMails, isLoadingGlobalMails } = useGetGlobalMails();

  if (isLoadingGlobalMails) return <LoadingSpinner />;
  if (!globalMails) return <Alert severity='error'>Zugriff verweigert</Alert>;

  return <GlobalMailView initialMails={globalMails} />;
};
